function TopUpMemberSchema(values) {
    let errors = {};

    if (!values.MemberNO)
        errors.MemberNO = 'MemberNO is required';

    if (!values.TopUpAmount)
        errors.TopUpAmount = 'TopUpAmount is required';

    if (!values.PaidAmount)
        errors.PaidAmount = 'PaidAmount is required';

    if (values.PaidAmount < values.TopUpAmount)
        errors.PaidAmount = 'PaidAmout not enough';

    if (!values.PaymentTypeID)
        errors.PaymentTypeID = 'PaymentTypeID is required';

    return errors;
};

export default TopUpMemberSchema;
